import './track-js'
import './errorHandler'
import './ketch'
import './analytics/googleTagManager'
import dataDogLoader from './dataDog'
import analyticsLoader from './analytics/gtag'

dataDogLoader()
analyticsLoader()
